// src/pages/IndirectIncomeBalanceLedger/IndirectIncomeBalanceLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getIndireactIncomeLedgerApi } from "../../../apiservice/reports";
import { getAccountBySeachApi } from "../../../apiservice/setting";

export const fetchIndirectIncomeBalanceLedger = createAsyncThunk(
  "indirectIncomeBalanceLedger/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getIndireactIncomeLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchIndirectIncomeAccountsBySearch = createAsyncThunk(
  "indirectIncomeBalanceLedger/fetchAccountsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        query: search.trim(),
        search: true,
        multiType: ["indirect_income"],
      });
      return (res.data || []).map((c) => ({
        sale_id: c.acc_id,
        display_text: c.acc_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);